module.exports = __webpack_public_path__ + "img/05.1997ac41.png";